import moment from "moment";
import { removeTimeFromDate } from "../../../helpers/removeTimeFromDate";

export function useGestionAsistencialInputs({
  handleChangeFilters,
  initialValues,
  setIsRefetchRequired,
}) {
  const handleChangeDate = (value, name) => {
    const nuevaFecha = value ? moment(value).format("yyyy-MM-DD") : null;
    handleChangeFilters(name, nuevaFecha);
  };

  const handleChangeFechaDesde = (value, name) => {
    const fechaDesdeFormatted = removeTimeFromDate(initialValues.fechaDesde)
    
    if (value !== fechaDesdeFormatted) {
      setIsRefetchRequired(true);
    }
    handleChangeDate(value, name);
  };

  const handleChangeFechaHasta = (value, name) => {
    const fechaHastaFormatted = removeTimeFromDate(initialValues.fechaHasta)

    if (value !== fechaHastaFormatted) {
      setIsRefetchRequired(true);
    }
    handleChangeDate(value, name);
  };


  const handleChange = (e) => {
    const { value, name } = e.target;
    handleChangeFilters(name, value);
  };

  return {
    handleChange,
    handleChangeDate,
    handleChangeFechaDesde,
    handleChangeFechaHasta,
  };
}
